import styled from 'styled-components';

export const StyledButton = styled.button.attrs({ type: 'button' })`
  height: 28px;
  cursor: pointer;
  border: 0;
  background: ${({ theme }) => theme.colors.gray1};
  color: ${({ theme }) => theme.colors.link};
  outline: 0;
  border-radius: 15px;
  padding: 5px 13px 5px 12px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;

  &:not(:disabled):not([disabled]) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.light};
      padding: 4px 12px 4px 11px;
    }

    &:active {
      border: 1px solid ${({ theme }) => theme.colors.lighter};
      color: ${({ theme }) => theme.colors.lighter};
      padding: 4px 12px 4px 11px;
    }
    
    &:focus-visible, &:focus {
      box-shadow: ${({ theme }) => theme.boxShadows?.focus};
    }
  
    &:focus:not(&:focus-visible) {
      box-shadow: none;
    }
  }  
  
  &:disabled, &[disabled] {
    color: ${({ theme }) => theme.colors.gray4};
    cursor: default;
  }
`;

export const StyledLeftIcon = styled.svg`
  position: relative;
  margin-right: 4px;
  margin-bottom: -3px;
  width: 18px;
  height: 18px;
`;

export const StyledRightIcon = styled.svg`
  position: relative;
  margin-left: 4px;
  margin-bottom: -3px;
  width: 18px;
  height: 18px;
`;
